import { Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { RoutesUrl } from "../../common/consts/Routes";
import { find, findAndUpdate, getData, store } from "../../services/service";
import CardComponent from "../shared/CardComponent";
import FormComponent, { FormData } from "../shared/test";

function NewClient() {
  let { id }: any = useParams();
  const { push } = useHistory();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState<FormData>({
    dynamicRows: [] as any,
  });
  const [clientNames, setClientNames] = useState<string[]>([""]);
  useEffect(() => {
    getData("clients").then((clients) => {
      if (clients.length > 0) {
        setClientNames(clients.map(el => el.name))
      }
    });
    if (id) {
      setIsLoading(true);
      find("parametrics", id)
        .then((val) => {
          if (!!!val?.dynamicRows) {
            val.dynamicRows = [];
          }
          setFormData(val);
        })
        .finally(() => setIsLoading(false));
    } else {
      setFormData({
        dynamicRows: [] as any,
      });
    }
  }, [id]);
  console.log(formData);
  return (
    <Box>
      <CardComponent title={`New Parametrics`} isLoading={isLoading}>
        <FormComponent
          staticFields={[
            {
              name: "project",
              label: "Име на проект",
              type: "text",
              required: true
            },
            {
              name: "choose-client",
              label: "Клиент",
              type: "autocomplete",
              options: clientNames,
              required: true
            },
            {
              name: "marketing-platform",
              label: "Платформа",
              type: "autocomplete",
              options: [
                "Facebook",
                "Google",
                "Instagram"
              ],
              required: true,
              validation: (v) => {
                if (!v) {
                  return "Полето е задължително!";
                }
              },
            },
            {
              name: "product-description",
              label: "Описание на продукт",
              type: "text",
              required: true,
              textFieldProps: {
                multiline: true,
                inputProps: {
                  maxLength: 160
                }
              }
            },
            {
              name: "campaign-language",
              label: "Език",
              type: "autocomplete",
              options: [
                "Български",
                "Английски",
                "Немски"
              ],
              required: true,
            },
            {
              name: "target-country",
              label: "Държава",
              type: "autocomplete",
              options: [
                "България",
                "САЩ",
                "Великобритания",
                "Германия"
              ],
              required: true,
            },
            {
              name: "event",
              label: "Описание на събитието",
              type: "text",
              required: true,
              textFieldProps: {
                multiline: true,
                inputProps: {
                  maxLength: 160
                }
              }
            },
          ]}

          dynamicPlural="Лицa за контакт"
          dynamicSingle="Лице за контакт"
          onSubmit={async (data) => {
            try {
              if (id) {
                await findAndUpdate("parametrics", id, data);
                toast.success("Успешно редактиране");
                push(RoutesUrl.parametricsPro.list);
                return;
              }
              await store("parametrics", data);
              toast.success("Успешно добавяне");
              push(RoutesUrl.parametricsPro.list);
              return true;
            } catch (e) {
              toast.error("Нещо се обърка");
              console.error(e);
              return false;
            }
          }}
          editMode={id ? true : false}
          formData={formData}
          setFormData={setFormData}
        />
      </CardComponent>
    </Box>
  )
}

export default NewClient;